import axios from "axios";
import Icon, { ICONS } from "components/common/Icons";
import FixedButton from "components/common/buttons/FixedButtons";
import Button from "components/common/buttons/buttons";
import TopHeader from "components/common/header";
import Input from "components/common/inputs";
import RiskAlarmAgreeModal from "components/modals/RiskAlarmAgreeModal";
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import useIsMobile from "states/deviceState";
import { TYPO } from "styles/Typo";
import { useRouter } from "next/router";
import DividerLine from "components/common/divider/line";
import Image from "next/image";
import NotiFooter from "components/layouts/m/Footer/noti";
import AlarmSelectModal from "components/modals/alarmSelectModal";
import AlarmLeaveModal from "components/modals/alarmLeaveModal";
import AlarmNewMailModal from "components/modals/alarmNewMailModal";
import AlarmVerfyPhoneModal from "components/modals/alarmVerifyPhoneModal";
import Lottie from "lottie-react";
import alarmAnimation from "../../../../../public/lottie/alarm.json";
import * as Sentry from "@sentry/nextjs";

function RiskAlarmRegister({ setModalOpen, detailData }: any) {
  const isMobile = useIsMobile();

  const router = useRouter();

  const { data: session, update }: any = useSession();
  const [agreeModalOpen, setAgreeModalOpen] = useState(false);
  const [complete, setComplete] = useState(false);

  //----------최종 알림 받기 신청 로직-------
  const submitHandler = async () => {
    try {
      const response = await axios.post(`/api/auth/alarm`, {
        // phone: phoneNumber,
        email: session?.user?.email || undefined,
        ITEM_CD_DL: detailData.ITEM_CD_DL,
        ITEM_ENG_NM: detailData.ITEM_ENG_NM,
        ITEM_KR_NM: detailData.ITEM_KR_NM,
        newEmail: newMail.length > 0 ? newMail : undefined,
        method: selectedAlarm + 1,
      });
      if (response.status === 200) {
        update();
        setComplete(true);
      }
    } catch (e: any) {
      Sentry.captureException(e);

      setComplete(false);
    }
    setAgreeModalOpen(false);
  };
  const { t } = useTranslation("detail");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const descs = [
    { main: t("situation1"), sub: t("situation1Sub") },
    { main: t("situation2"), sub: t("situation2Sub") },
    { main: t("situation3"), sub: t("situation3Sub") },
  ];

  const [isActive, setIsActive] = useState("message");

  const [newMailModal, setNewMailModal] = useState(false);
  const [newMail, setNewMail] = useState("");
  const [alarmSelectModal, setAlarmSelectModal] = useState(false);
  const [selectedAlarm, setSelectedAlarm] = useState(0); // 0: 문자메세지, 1: 이메일
  const [leaveModal, setLeaveModal] = useState(false);
  const selects = [t("textMessage"), t("email")];

  // console.log("newMailModal", newMailModal);

  const formatPhoneNumber = () => {
    if (session?.user?.phone === null) return "";
    return session?.user?.phone.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  };

  const [verifyModal, setVerifyModal] = useState(false);

  return (
    <>
      <div
        className={`bg-white absolute top-0 ${
          complete || verifyModal ? "h-screen" : ""
        }  ${
          !verifyModal ? "justify-center" : ""
        }  pb-[100px] z-6 flex flex-col  items-center ${
          isMobile
            ? "top-0 left-0 w-screen "
            : "top-[60px] left-[50%] transform -translate-x-1/2 w-[800px]"
        }`}
        style={
          !isMobile
            ? complete
              ? { height: "calc(100vh - 60px)" }
              : verifyModal
              ? { height: "calc(100vh - 60px)" }
              : { minHeight: "calc(100vh - 60px)" }
            : {}
        }
      >
        {verifyModal && <AlarmVerfyPhoneModal setModalOpen={setVerifyModal} />}
        {!verifyModal && complete && (
          <>
            <div
              className={`alarm-complete flex  flex-col gap-[11px] justify-center w-full items-center`}
            >
              <Lottie
                animationData={alarmAnimation}
                renderer="svg"
                autoplay
                loop
                style={{ width: 120, height: 120 }}
              />
              <div className="flex flex-col px-6 py-4 text-center gap-[11px]">
                <h1 className={`${TYPO.TYPO4_B} text-gray80`}>
                  {t("willReceive")}
                </h1>
                <span
                  className={`${TYPO.TYPO6_RG} text-gray60 whitespace-pre-line`}
                >
                  {t("willReceiveDesc")}
                </span>
              </div>
            </div>
            <div className="z-[50]">
              <FixedButton
                type={"primary"}
                size={"lg"}
                text={t("confirm")}
                width="w-fit"
                isDesktop={!isMobile}
                rounded={true}
                onclick={() => {
                  setModalOpen(false);
                }}
              />
            </div>
          </>
        )}
        {!verifyModal && !complete && (
          <>
            <div className="relative h-full pb-[30px] w-full">
              <TopHeader
                clickHandler={() => {
                  // setModalOpen(false);
                  setLeaveModal(true);
                }}
                // title={t("alarmPreRegister")}
              />
              <div className="flex flex-col gap-6 ">
                <div className="flex mt-5 px-5 gap-2 items-center">
                  <div
                    onClick={() => {
                      setAlarmSelectModal(true);
                    }}
                    className="flex w-fit cursor-pointer items-center gap-[6px] px-[10px] py-[6px] bg-gray2 border-[1px] border-gray10 rounded-[12px]"
                  >
                    <span className={`${TYPO.TYPO4_SB} text-blue50`}>
                      {selects[selectedAlarm]}
                    </span>
                    <Icon
                      name={ICONS.EXPAND}
                      width={16}
                      height={16}
                      fill="blue50"
                    />
                  </div>
                  <span className={`${TYPO.TYPO4_SB} text-gray90`}>
                    {router.locale === "ko" ? "로 받기" : "for Notification"}
                  </span>
                </div>
                <div className="flex flex-col gap-4  px-6">
                  <div className="flex flex-col gap-[1px]">
                    <span className={`${TYPO.TYPO7_MD} text-gray50 `}>
                      {selectedAlarm === 0
                        ? t("phoneNumber")
                        : t("emailAddress")}
                    </span>
                    <div className="flex items-center">
                      <p className={`${TYPO.TYPO5_MD} text-gray80`}>
                        {selectedAlarm === 0
                          ? session?.user?.phone
                            ? formatPhoneNumber()
                            : t("needVerify")
                          : newMail.length > 0
                          ? newMail
                          : session
                          ? session?.user?.email
                          : ""}
                      </p>
                      {selectedAlarm === 0 && session?.user?.phone && (
                        <Icon
                          name={ICONS.SECURE}
                          height={24}
                          width={24}
                          fill="blue50"
                        />
                      )}
                    </div>
                  </div>
                  {!session?.user?.phone && selectedAlarm === 0 && (
                    <Button
                      width="w-fit"
                      type={"primary"}
                      size={"sm"}
                      text={t("goVerify")}
                      clickHandler={() => {
                        setVerifyModal(true);
                      }}
                      icon={ICONS.FORWARD}
                      iconHeight={12}
                      iconWidth={12}
                    />
                  )}
                  {selectedAlarm === 1 && (
                    <Button
                      type={"tertiary"}
                      size={"sm"}
                      text={t("anotherEmail")}
                      width="w-fit"
                      clickHandler={() => {
                        setNewMailModal(true);
                      }}
                      icon={ICONS.FORWARD}
                      iconHeight={12}
                      iconWidth={12}
                    />
                  )}
                </div>

                <DividerLine size="lg" />
                <div className="flex flex-col gap-4 px-6">
                  <p className={`${TYPO.TYPO7_1_SB} text-gray70`}>
                    {t("situationsLike")}
                  </p>
                  {descs.map((desc, idx) => (
                    <div className="flex items-center gap-4" key={idx}>
                      <span
                        className={`rounded-[50%] px-[7px] w-6 h-6 flex justify-center items-center py-1 bg-blue5 text-center text-blue50 text-lg font-semibold leading-none`}
                      >
                        {idx + 1}
                      </span>
                      <div className="flex flex-col">
                        <span className={`${TYPO.TYPO7_SB} text-gray80`}>
                          {desc.main}
                        </span>
                        <p className={`${TYPO.TYPO7_1_RG} text-gray50`}>
                          {desc.sub}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                <DividerLine size="lg" />
                <span className={`${TYPO.TYPO5_SB} text-gray80 px-6`}>
                  {t("notiPreview")}
                </span>
                <div className="px-6 z-[44]">
                  <div className="w-full h-[42px] p-1.5 bg-gray5 rounded-[10px] justify-start items-start gap-2 inline-flex">
                    <div
                      className={`cursor-pointer grow shrink basis-0 h-[30px] px-2.5 py-1  ${
                        isActive === "message" && "bg-white"
                      } rounded-md  justify-center items-center gap-1 flex`}
                      style={
                        isActive === "message"
                          ? {
                              boxShadow:
                                "0px 0px 6px 0px rgba(42, 41, 51, 0.08)",
                            }
                          : {}
                      }
                      onClick={() => {
                        setIsActive("message");
                      }}
                    >
                      <span
                        className={`${TYPO.TYPO7_MD} !text-[14px] ${
                          isActive === "message" ? "text-gray80" : "text-gray40"
                        }`}
                      >
                        {t("textMessage")}
                      </span>
                    </div>
                    <div
                      className={`cursor-pointer grow shrink basis-0 h-[30px] px-2.5 py-1 ${
                        isActive === "email" && "bg-white"
                      } rounded-md justify-center items-center gap-1 flex`}
                      style={
                        isActive === "email"
                          ? {
                              boxShadow:
                                "0px 0px 6px 0px rgba(42, 41, 51, 0.08)",
                            }
                          : {}
                      }
                      onClick={() => {
                        setIsActive("email");
                      }}
                    >
                      <span
                        className={`${TYPO.TYPO7_MD} !text-[14px] ${
                          isActive === "email" ? "text-gray80" : "text-gray40"
                        }`}
                      >
                        {t("email")}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="relative w-full flex justify-center mt-[-50px]">
                  <Image
                    src={`/images/learn/phonePrame.png`}
                    alt="phone"
                    width={375}
                    height={584}
                    className="z-10"
                  />
                  <div
                    className={`w-[211px] h-[23px] 
                    ${
                      isActive === "message" ? "  bg-[#f2f2f2]" : "bg-[#fcfeff]"
                    }
                    absolute top-[12%] left-[50%] translate-x-[-50%] translate-y-[-50%] `}
                    style={{ borderRadius: "10px 10px 0 0" }}
                  ></div>
                  <Image
                    src={
                      isActive === "message"
                        ? `/images/detail/messageTemplate.png`
                        : `/images/detail/emailTemplate.png`
                    }
                    alt="phone"
                    width={211}
                    height={442}
                    className="absolute top-[51%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-0"
                  />
                </div>

                <DividerLine size="lg" />
                <div className="px-6 flex flex-col gap-3">
                  <p className={`${TYPO.TYPO6_SB} text-gray70`}>
                    {t("alarmSendTime")}
                  </p>
                  <table className="time-table ">
                    <thead>
                      <tr className={`${TYPO.TYPO7_1_SB} text-gray70`}>
                        <th className="bg-gray5">{t("koreanStock")}</th>
                        <th className="bg-gray5">{t("globalStock")}</th>
                        <th className="bg-gray5">{t("crypto")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        className={`${TYPO.TYPO7_1_RG} text-gray60 text-center`}
                      >
                        <td>7:30am</td>
                        <td>7:30pm</td>
                        <td>10:30am</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="px-6">
                    <ul
                      className={`${TYPO.TYPO7_1_RG} text-gray50  list-outside `}
                    >
                      <li className="pl-[-5px] list-disc break-keep ">
                        {t("alarmSendTimeDesc")}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {isMobile && (
                <FixedButton
                  type={"primary"}
                  size={"lg"}
                  text={t("next")}
                  onclick={() => {
                    if (!session?.user?.phone && selectedAlarm === 0) {
                      return;
                    }
                    setAgreeModalOpen(true);
                  }}
                  rounded={true}
                  disabled={!session?.user?.phone && selectedAlarm === 0}
                  isDesktop={!isMobile}
                  zIndex={100}
                />
              )}
            </div>
            <div>
              <NotiFooter />
            </div>
          </>
        )}
      </div>

      {!complete && !isMobile && !verifyModal && (
        <div className="z-[100] px-5 pt-4 pb-9 fixed bottom-0 w-[800px] left-[50%] transform -translate-x-1/2 bg-white">
          <Button
            type={"primary"}
            size={"lg"}
            text={t("next")}
            disabled={!session?.user?.phone && selectedAlarm === 0}
            width="w-full"
            clickHandler={() => {
              if (!session?.user?.phone && selectedAlarm === 0) {
                return;
              }
              setAgreeModalOpen(true);
            }}
          />
        </div>
      )}
      {agreeModalOpen && (
        <RiskAlarmAgreeModal
          setModalOpen={setAgreeModalOpen}
          isModalOpen={agreeModalOpen}
          setComplete={setComplete}
          submitHandler={submitHandler}
        />
      )}
      {leaveModal && (
        <AlarmLeaveModal
          setModal={setLeaveModal}
          setAlarmModal={setModalOpen}
        />
      )}
      {newMailModal && (
        <AlarmNewMailModal
          setModalOpen={setNewMailModal}
          isModalOpen={newMailModal}
          setNewMail={setNewMail}
          newMail={newMail}
        />
      )}
      {alarmSelectModal && (
        <AlarmSelectModal
          data={selects}
          index={selectedAlarm}
          selectIndex={setSelectedAlarm}
          setModal={setAlarmSelectModal}
          isModalOpen={alarmSelectModal}
        />
      )}
      {/* {verifyModal && <AlarmVerfyPhoneModal setModalOpen={setVerifyModal} />} */}
    </>
  );
}
export default RiskAlarmRegister;
